import(/* webpackMode: "eager" */ "/opt/render/project/src/node_modules/@fontsource/mulish/400.css");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/node_modules/@fontsource/mulish/700.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/src/app/ClientProviders.jsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/src/app/styles/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/src/components/GlobalLoader.jsx");
